// src/page/main/projectPage/header/createProject/ProjectCreate.tsx
import React, { useState, useEffect } from "react";
import {
  Overlay,
  Dialog,
  Header,
  Title,
  Desc,
  Form,
  Field,
  Label,
  Input,
  Actions,
  Button,
  ApiError,
} from "./styles";

import { storageAPI } from "api";
import { useTaskStore } from "store/task";

interface ProjectCreateProps {
  isOpen: boolean;
  onClose: () => void;
}

const ProjectCreate = ({ isOpen, onClose }: ProjectCreateProps) => {
  const { addTask } = useTaskStore();

  const [projectName, setProjectName] = useState("");
  const [apiErr, setApiErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const nameInvalid = projectName.trim().length === 0;
  const canSubmit = !nameInvalid && !loading;

  const Close = () => {
    setProjectName("");
    setApiErr(null);
    setLoading(false);
    onClose();
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;

    try {
      setLoading(true);
      setApiErr(null);

      const res = await storageAPI.createProject(projectName.trim());

      // 작업 트래커 쓰는 구조면
      if (res?.data?.task_id) {
        addTask({
          name: projectName,
          id: res.data.task_id,
          job: "Create Project",
          state: "pending",
        });
      }

      Close();
    } catch (err: any) {
      setApiErr(err?.message || "Failed to create project.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setProjectName("");
      setApiErr(null);
      setLoading(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <Overlay
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) {
          e.preventDefault();
          e.stopPropagation();
          Close();
        }
      }}
    >
      <Dialog role="dialog" tabIndex={-1}>
        <Header>
          <Title>Create Project</Title>
        </Header>

        <Desc>새 프로젝트를 생성합니다.</Desc>

        {apiErr && <ApiError role="alert">{apiErr}</ApiError>}

        <Form onSubmit={onSubmit}>
          <Field>
            <Label $invalid={nameInvalid}>Project Name</Label>
            <Input
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
              placeholder="ex) cmp-production"
              $invalid={nameInvalid}
              autoFocus
            />
          </Field>

          <Actions>
            <Button type="button" onClick={Close} data-variant="ghost">
              Cancel
            </Button>
            <Button type="submit" disabled={!canSubmit}>
              {loading ? "Creating..." : "Create"}
            </Button>
          </Actions>
        </Form>
      </Dialog>
    </Overlay>
  );
};

export default ProjectCreate;
